import React, { useEffect, useState } from 'react';
import '../../assets/css/Demographics/Demographics.css';
import { Card, Row, Col, Button, Form, ListGroup, Badge } from 'react-bootstrap';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';
import decryptData from '../../helpers/Decryption';
import { toast } from 'react-toastify';
import { faUserCheck, faEnvelope, faMapMarkerAlt, faBell, faChartBar, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RewardCard from './RewardCard';

const tierOptions = ['Bronze', 'Silver', 'Gold', 'Platinum'];
const ageOptions = ['18 to 29', '30 to 39', '40 to 49', '50 to 59', '60 to 69', '70 to 79', '80 or over'];
const locationOptions = ['ON (Foreground/Background)', 'ON (All the time)'];
const demographicsOptions = ['0-50%', '50%-100%', '90-100%', '100%'];

const RewardSettings = () => {
    const { getToken, user } = useAuth();
    const [rewards, setRewards] = useState([]);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editedReward, setEditedReward] = useState(null);
    const [commutersData, setCommutersData] = useState(false);

    const fetchDemographicsRewards = async () => {
        try {
            const _resp = await new WebApiCalls().getDemographics(getToken());
            if (_resp?.data) {
                const all = await decryptData(_resp?.data);
                setRewards(all);
            }
        } catch (error) {
            console.error('Error fetching rewards:', error);
        }
    };

    useEffect(() => {
        fetchDemographicsRewards();
    }, []);

    const handleEdit = (index) => {
        setEditingIndex(index);
        setEditedReward({ ...rewards[index] });
    };

    const handleInputChange = (e, field) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setEditedReward({ ...editedReward, [field]: value });
    };

    const handleSave = async () => {
        if (editedReward) {
            try {
                const resp = await new WebApiCalls().updateDemographicReward(getToken(), editedReward, editedReward?._id);
                if (resp?.data) {
                    fetchDemographicsRewards();
                    setEditingIndex(null);
                    toast.success(resp?.desc || 'Demographic Reward Updated Successfully');
                }
            } catch (error) {
                console.error('Error updating reward:', error);
            }
        }
    };

    useEffect(() => {
        if (user?.role === 'commuter' && user?._id) {
            const getDashboardCommuter = () => {
                const authToken = getToken();
                if (authToken) {
                    new WebApiCalls().getCommuterDasboardData(authToken, user?._id, user?.created_at, new Date().toISOString()).then((res) => {
                        setCommutersData(res?.data);
                    });
                }
            };

            getDashboardCommuter();
        }
    }, [user?._id, user?.role, user?.created_at, getToken]);

    return (
        <div className="p-4 mx-auto bg-light d-flex flex-column align-items-center py-5">
            <Row className="w-100 m-0 p-2 py-4">
                {rewards.map((reward, index) => (
                    <RewardCard
                        key={index}
                        reward={reward}
                        index={index}
                        editingIndex={editingIndex}
                        editedReward={editedReward}
                        handleEdit={handleEdit}
                        handleInputChange={handleInputChange}
                        handleSave={handleSave}
                        setEditingIndex={setEditingIndex}
                        demographicsOptions={demographicsOptions}
                        role={user?.role}
                        current={commutersData?.tier === reward.tier ? true : false}
                    />
                ))}
            </Row>
        </div>
    );
};

export default RewardSettings;
